import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { SystemInput } from "../../shared/SystemInput";
import { inlineInputStateStyles } from "./InlineInputState";

export const System: FC<InputProps<string[]>> = props => (
  <SystemInput inlineInputStateStyles={inlineInputStateStyles} {...props} />
);
